import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { WalletLinkConnector } from "@web3-react/walletlink-connector";
import Web3 from "web3";
import { DEFAULT_CHAIN } from "./constant";
import { supportNetwork, RPC_URLS } from './network';

export const infura_Id = "c340baf441a74c52ba27da70425a1ae2";

export const getWeb3 = () => {
  let setRpc = supportNetwork[DEFAULT_CHAIN].rpc;
  return new Web3(setRpc);
}

export const supportChainId = Object.keys(supportNetwork).map(function (key) {
  return parseInt(key);
});



export const injected = new InjectedConnector({
  supportedChainIds: supportChainId
})

export const walletconnect = new WalletConnectConnector({
  rpc: RPC_URLS,
  qrcode: true,
  infuraId: infura_Id,
});

export const coinbaseWallet = new WalletLinkConnector({

  url: `https://mainnet.infura.io/v3/c340baf441a74c52ba27da70425a1ae2`,
  appName: "cabon App",
  supportedChainIds: supportChainId,

});
